import React, { useState, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import RichEditorResultText from './Shared/RichEditorResultText';
import RichEditor from './Shared/RichEditor';
import RequiredCheckbox from './Shared/RequiredCheckbox';
import AdmicityAddressLookup from '../../../../../shared-components/AdmicityAddressLookup';
import { stripHtmlTags } from './AdditionalNotes';

const Address = ({
    index,
    id,
    value,
    onChange,
    description,
    isEditMode,
    enableValidation,
    isFormArchived,
    accessLevel,
    readonly,
    placeholderValues,
    onUpdateDescription,
    componentToEditIndex,
    error
}) => {
    const [currentValue, setCurrentValue] = useState(description);
    const prevPropRef = useRef();

    useEffect(() => {
        setCurrentValue(description);
    }, [description]);

    useEffect(() => {
        if (prevPropRef.current === index && componentToEditIndex !== prevPropRef.current) {
            onUpdateDescription({ index, description: stripHtmlTags(currentValue), formattedDescription: currentValue });
        }
        prevPropRef.current = componentToEditIndex;
    }, [componentToEditIndex, index, currentValue, onUpdateDescription]);

    const handleAddressSelect = (address) => {
        onChange({ id, value: address });
    };

    const renderEditMode = () => (
        <Box>
            <RichEditor
                value={description}
                onChange={onChange}
                id={id}
                index={index}
                isEditMode={isEditMode}
                isFormLive={isFormArchived}
                accessLevel={accessLevel}
                currentDescription={currentValue}
                setCurrentDescription={setCurrentValue}
            />
            <RequiredCheckbox enableValidation={enableValidation} index={index} onChange={onChange}
                              isFormArchived={isFormArchived}/>
        </Box>
    );

    const renderViewMode = () => (
        <>
            <RichEditorResultText
                id={id}
                description={description}
                placeholderValues={placeholderValues}
                readonly={readonly}
                enableValidation={enableValidation}
            />
            <Box mt={2}>
                <AdmicityAddressLookup
                    onAddressSelect={handleAddressSelect}
                    readonly={readonly}
                    initialValue={value}
                    defaultCountry={process.env.REACT_APP_DEFAULT_COUNTRY}
                    errors={error}
                    enableValidation={enableValidation}
                />
            </Box>
        </>
    );

    return <Box sx={{mt: 2}}>{isEditMode ? renderEditMode() : renderViewMode()}</Box>;
};

Address.propTypes = {
    id: PropTypes.string,
    value: PropTypes.object,
    index: PropTypes.number,
    description: PropTypes.string,
    enableValidation: PropTypes.bool,
    onChange: PropTypes.func,
    isEditMode: PropTypes.bool,
    isFormArchived: PropTypes.bool,
    readonly: PropTypes.bool,
    accessLevel: PropTypes.number,
    placeholderValues: PropTypes.object,
    onUpdateDescription: PropTypes.func,
    componentToEditIndex: PropTypes.number,
    error: PropTypes.object,
};

export default Address;